export async function getMyTeamStatus({ userId, token }) {
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/getMyTeamStatus`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token || ""}`,
    },
    body: JSON.stringify({ userId }),
  });

  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data?.message || "Failed to fetch team status");
  }
  return data;
}
